import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  list: Record<string, any> | null;
  current: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
  history: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  list: null,
  current: {
    isLoading: false,
    data: null,
    error: null,
  },
  history: {
    isLoading: false,
    data: null,
    error: null,
  },
};

export const { actions: jobActions, reducer: jobReducer } = createSlice({
  name: 'job',
  initialState,
  reducers: {
    getCurrentPositionRequest: (state) => {
      state.current = {
        isLoading: true,
        data: null,
        error: null,
      };
    },

    getCurrentPositionSuccess: (state, { payload }) => {
      state.current = {
        isLoading: false,
        data: payload.data,
        error: null,
      };
      state.list = {
        ...state.list,
        [payload.pinfl]: payload.data,
      };
    },

    getCurrentPositionFailure: (state, { payload }) => {
      state.current = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },

    getPositionHistoryRequest: (state) => {
      state.history = {
        isLoading: true,
        data: null,
        error: null,
      };
    },

    getPositionHistorySuccess: (state, { payload }) => {
      state.history = {
        isLoading: false,
        data: payload.data,
        error: null,
      };
      // console.log(payload);
      state.list = {
        ...state.list,
        [payload.pinfl]: payload.data,
      };
    },

    getPositionHistoryFailure: (state, { payload }) => {
      state.history = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },

    setUserPosition: (state, { payload }) => {},
  },
});
